"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const UserMessage = ({ message, openImageModal, time }) => {
    const [isHover, setIsHover] = (0, react_1.useState)(false);
    const downloadImage = (image) => {
        const imageLink = document.createElement("a");
        imageLink.href = image;
        imageLink.download = `이미지_${Date.now()}.png`;
        imageLink.click();
        imageLink.remove();
    };
    const messageStyle = {
        display: "flex",
        maxWidth: "58%",
        padding: "8px",
        margin: "8px",
        fontSize: "1rem",
        color: "#1b1b1b",
        wordBreak: "break-word",
        background: "tomato",
        borderRadius: "6px",
    };
    const boxStyle = {
        position: "relative",
        display: "flex",
        flex: "1",
        flexFlow: "row-reverse",
        width: "100%",
        margin: 0,
        marginLeft: "auto"
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", { style: boxStyle },
            message.slice(0, 5) !== '@$IMG' ?
                react_1.default.createElement("span", { "data-testid": "user", style: messageStyle }, message) :
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("img", { "data-testid": "user-image", src: message.slice(5), style: messageStyle, onClick: () => openImageModal(message.slice(5)), onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false), alt: "\uC804\uC1A1\uB41C \uC774\uBBF8\uC9C0" }),
                    isHover &&
                        react_1.default.createElement("button", { style: {
                                position: "absolute",
                                margin: "8px",
                                padding: "3px",
                                fontSize: "0.8rem",
                                color: "#cecece",
                                background: "rgb(255, 99, 71, 50%)",
                                border: "none",
                            }, onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false), onClick: () => downloadImage(message.slice(5)) }, "Download")),
            react_1.default.createElement("time", { style: {
                    display: "flex",
                    alignItems: "flex-end",
                    marginBottom: "8px",
                    fontSize: "0.7rem",
                } }, time))));
};
exports.default = UserMessage;
